var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.656 14.9731C21.1147 13.0176 21.1147 10.9824 20.656 9.02691C19.9945 6.20715 17.7929 4.00546 14.9731 3.34403C13.0176 2.88532 10.9824 2.88532 9.02691 3.34403C6.20714 4.00546 4.00545 6.20715 3.34403 9.02692C2.88532 10.9824 2.88532 13.0176 3.34403 14.9731C4.00545 17.7929 6.20715 19.9945 9.02691 20.656C10.9824 21.1147 13.0176 21.1147 14.9731 20.656C17.7928 19.9945 19.9945 17.7929 20.656 14.9731ZM15.2473 9.42229C15.5238 9.6863 15.534 10.1245 15.27 10.4011L11.7455 14.0934C11.6178 14.2273 11.4417 14.3044 11.2567 14.3076C11.0717 14.3108 10.8931 14.2398 10.7608 14.1104L8.74676 12.1412C8.47338 11.8739 8.46846 11.4355 8.73576 11.1622C9.00307 10.8888 9.44139 10.8838 9.71477 11.1511L11.2278 12.6305L14.2684 9.44506C14.5325 9.16848 14.9707 9.15829 15.2473 9.42229Z",
    fill: "#00AA25"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckFilled);
export default __webpack_public_path__ + "static/media/icon-check-filled.c09e1d8a35169627857259c0466ed4c9.svg";
export { ForwardRef as ReactComponent };